// extracted by mini-css-extract-plugin
export default {"link":"ExecSummaryLink_link__KlcCF","spacer":"ExecSummaryLink_spacer__F3UUC"};